import { useMemo } from "react";

import { isAfter } from "date-fns";

import { hasValidFilters } from "@/containers/Filters/utils";
import { useEpisodes } from "@/contexts/EpisodesContext";
import useSearchParams from "@/hooks/useSearchParams";
import { indexUsing } from "@/utils";

// Find out whether we have an item in the array that is after the last_read_at timestamp

const useShowUnreadNotice = () => {
  const [filter] = useSearchParams();
  const isFilteredView = hasValidFilters(filter);
  const [{ sort_by = undefined }] = useSearchParams();
  const { episodes, alert } = useEpisodes();

  const index = useMemo(() => {
    if (!alert?.last_read_at) return -1;

    const at = new Date(alert.last_read_at);

    return indexUsing(episodes, (mention) => {
      const mentionDate = new Date(mention?.post_data?.published_date);
      return isAfter(at, mentionDate);
    });
  }, [episodes, alert?.last_read_at]);

  // Don't give a positive index if:
  return !isFilteredView && // - The user has not filtered for anything
    index !== 0 && // - This is not the first episode we're seeing on the first page.
    (sort_by === "date" || sort_by === undefined) // ... And we've sorted by anything else than date ( which is default, hence || undefined)
    ? index
    : -1; // -1 never hits any index in the render map so return that
};

export default useShowUnreadNotice;
